import React from 'react';
import { applyStyles } from 'util/helpers';
import { css } from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import Jump from 'components/common/Jump';
import Content from './components/Content';
import i18n from 'i18n';
import Breadcrumbs from 'components/common/Breadcrumbs';
import GrayHeader from 'components/common/GrayHeader';

const faq = ({ className, location: { pathname } }) => (
  <div className={className}>
    <GrayHeader text={i18n.t('terms:grayHeader')} />
    <Breadcrumbs currentPath={pathname} />
    <Jump />
    <section>
      <Content />
    </section>
  </div>
);

const commonStyle = css``;

const pcStyle = CustomMedia.greaterThan('umedium')`
  max-width: 886px;
  margin-left: auto;
  margin-right: auto;

  ${Breadcrumbs} {
    margin-top: 12px;
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  margin: 0 16px;

  ${Breadcrumbs} {
    margin-top: 6px;
  }
`;

export default applyStyles(faq)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/Terms/index.js